const text = require('./text.yaml')[templateVars.lang];

var inputFocus = false;
var breakSlider = {};
breakSlider.mobileWidth = 641;
breakSlider.mobileHeight = 501;

var inited = false;

function setPosition(elem) {
	const $this = elem;
	var sliderBgWidth = $this.width();
	var sliderBgHeight = $this.height();
	var windowHeight = $this.parent().height();
	var windowWidth = $this.parent().width();
	var topPosition = -Math.abs((windowHeight - sliderBgHeight) / 2);
	var leftPosition = -Math.abs((windowWidth - sliderBgWidth) / 2);

	if ((sliderBgHeight / sliderBgWidth) < (windowHeight / windowWidth)) {
		$this.css('left', leftPosition + 'px');
		$this.css('top', '0');
	} else {
		$this.css('top', topPosition + 'px');
		$this.css('left', '0');
	}
}

function setMobileSizeCentralizeBg() {
	var $bgQuery = $('.slide-bg');

	$bgQuery.each(function () {
		var $this = $(this);
		var sliderBgWidth = $this.width();
		var sliderBgHeight = $this.height();
		var windowHeight = $this.parent().height();
		var windowWidth = $this.parent().width();

		if ((sliderBgHeight / sliderBgWidth) < (windowHeight / windowWidth)) {
			$this.css('width', '');
			$this.css('height', '100%');

		} else {
			$this.css('width', '100%');
			$this.css('height', '');
		}
		//Вызываем функцию, которая подсчитает и проставит позиционирование для центрирования
		setPosition($(this));
	});
}

function checkWindow() {
	//check window width (scrollbar included)
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	if (e[a + 'Width'] < breakSlider.mobileWidth || e[a + 'Height'] < breakSlider.mobileHeight) {
		$('.slider').addClass('slider--mobile');
		setMobileSizeCentralizeBg();
		bgScale();
		return false;
	} else {
		$('.slider').removeClass('slider--mobile');
		return true;
	}
}

function bgScale() {
	$('.slide-bg').velocity({
		scale: 1.2
	}, {
		duration: 30000,
		easing: 'easeInOutSine',
		loop: true,
		mobileHA: true
	});
}

//задаем нужную ширину и высоту в зависимости от размера фотографий
function setSizeCentralizeBg() {
	var curSliderBg = $('.swiper-slide-active').find($('.slide-bg')),
		sliderBgHeight = curSliderBg.height(),
		sliderBgWidth = curSliderBg.width(),
		windowHeight = $(window).height(),
		windowWidth = $(window).width();

	if ((sliderBgHeight / sliderBgWidth) < (windowHeight / windowWidth)) {
		curSliderBg.css('width', '');
		curSliderBg.css('height', windowHeight + 'px');

	} else {
		curSliderBg.css('width', windowWidth + 'px');
		curSliderBg.css('height', '');
	}
	//Вызываем функцию, которая подсчитает и проставит позиционирование для центрирования
	setPosition($('.swiper-slide-active').find($('.slide-bg')));
}

function sliderInit() {
	$('.slider__slide').find($('.slide-bg')).css('height', '');

	if ($('.slider').length && $('.slider__slide').length) {
		const doLoop = Boolean($('.slider--casefilter').length);
		// правка к "единственному" слайду на странице
		const single = $('.slider__slide').length > 1 ? false : true;
			// false - null ?
		const pagination = single ? false : '.slider__pagination';
		//
		var mainSwiper;
		// исчезновение заголовка при скролле
		// const $heading = $('.b-header');

		function initSwiper() {
			if (!inited) {
				inited = true;
				$('.slider').wrapInner('<div class="swiper-wrapper"></div>');
				$('.slider').addClass('swiper-container');
				$('.slider__slide').addClass('swiper-slide');

				if (!single) {
					$('.swiper-container').append('<div class="slider__pagination"></div><div class="slider__arrow"></div>');
				}
			}

			mainSwiper = new Swiper('.swiper-container', {
				direction: 'vertical',
				loop: doLoop,
				speed: 800,
				keyboardControl: true,
				mousewheelControl: true,
				mousewheelReleaseOnEdges: true,
				createPagination: true,
				pagination: pagination,
				slidesPerView: 1,
				paginationClickable: true,
				preloadImages: true,
				updateOnImagesReady: true,
				simulateTouch: false,
				cssWidthAndHeight: 'width',
				hashnav: true,
				hashnavWatchState: true,
				onInit: function () {
					setSizeCentralizeBg();
				},
				onSlideChangeStart: function (swiper) {
					if (!doLoop) {
						var $sliderArrow = $('.slider__arrow');

						if (swiper.isEnd) {
							$sliderArrow.velocity('fadeOut', 100);
						} else if ($sliderArrow.is(':hidden')) {
							$sliderArrow.velocity('fadeIn', 300);
						}
					}

					// if($heading) {
					// 	$heading.velocity('fadeOut', 200);
					// }

					setSizeCentralizeBg();
				},

				onSlideChangeEnd: function () {
					// if($heading) {
					// 	$heading.velocity('fadeIn', 200);
					// }
				}

			});

			//проверка наличия и совпадения хешей
			function checkHash() {
				// прокрутка ко второму слайду Допилить изменить?
				if (mainSwiper) {
					var windowHash = window.location.hash,
						secondSlide = mainSwiper.slides[1],
						secondSlideHash = '#' + $(secondSlide).attr('data-hash');
					if (windowHash && windowHash == secondSlideHash) {
						mainSwiper.slideTo(1);
					}
				}
			}
			$(window).on('hashchange', checkHash);
			checkHash();
			//параметры стрелки вниз
			$('.slider__arrow').on('click', function () {
				mainSwiper.slideNext();
			});
			$('.slider__arrow').attr('title', text.downTitle);
			//высота пагинации для позиционирования
			var paginationHeight = $('.slider__pagination').height();
			$('.slider__pagination').css('height', paginationHeight);
			$('.slider__pagination').css('display', 'block');

			$(window).load(() => {
				setSizeCentralizeBg();
			});
			$(window).resize(() => {
				setSizeCentralizeBg();
			});
		}

		if ($('.slider').data('destroyable') != undefined) {
			$('.feedback__input')
				.on('focus', function () {
					if (mainSwiper) {
						inputFocus = true;
					}
				})
				.on('blur', function () {
					inputFocus = false;
				});

			(function () {
				var checkSwiper = function checkSwiper() {
					var desktop = checkWindow();

					if (desktop && mainSwiper == undefined) {
						initSwiper();
						bgScale();
					} else if (!desktop && mainSwiper !== undefined && !inputFocus) {
						mainSwiper.destroy(true, true);
						mainSwiper = undefined;

						if (doLoop) {
							$('.swiper-slide-duplicate').remove();
						}

						setMobileSizeCentralizeBg();
						bgScale();
					} else if (!desktop && mainSwiper == undefined) {
						setMobileSizeCentralizeBg();
						bgScale();
					}
				};

				mainSwiper = undefined;
				checkSwiper();

				$(window).on('resize', function () {
					checkSwiper();
				});
			}());
		} else {
			initSwiper();
			bgScale();
		}
	}
}

$(document).ready(function () {
	// ждем SVG на слайдерах
	if ($('body [data-svg]').length) {
		AR.events.on('svgRenderedAll', sliderInit);
	} else {
		sliderInit();
	}
});



// WEBPACK FOOTER //
// ./temp/components/slider/.variant/base/index.js